

 const useFunctions = (
)=> {

 

 

//   function groupMenuExploreItems(menuItems: any) {
//     console.log({menuItems});
    
//     const groupedItems = menuItems?.reduce((acc: any, currentItem: any) => {
//       if (currentItem?.isSpecial) {
//         // const existingGroup = acc?.find(
//         //   (group: any) => group?.title ===   currentItem?.specialName
//         // );
//          const existingGroup = acc?.find(
//           (group: any) =>   currentItem?.specialCategory?.some(
//     (sc: any) => sc?.specialName === group?.title
//   )
//         );

//         // console.log({existingGroup});
        
//         if (existingGroup) {
//           if (
//             !existingGroup?.displayType &&
//             currentItem?.digiMenuMedia?.[0]?.tag
//           )
//             existingGroup.displayType = currentItem?.digiMenuMedia?.[0]?.tag;
//           existingGroup.content.push({
//             image: currentItem?.digiMenuMedia && currentItem?.digiMenuMedia,
//             dishName: currentItem?.itemName,
//             menuData: currentItem,
//           });
//         } else {
//           acc.push({
//             title: currentItem?.specialName,
//             displayType: currentItem?.digiMenuMedia?.[0]?.tag,
//             desc: currentItem?.categoryDescription,
//             content: [
//               {
//                 image: currentItem?.digiMenuMedia && currentItem?.digiMenuMedia,
//                 dishName: currentItem?.itemName,
//                 menuData: currentItem,
//               },
//             ],
//           });
//         }
//       }
//       return acc;
//     }, []);
// console.log({groupedItems});

//     return groupedItems;
//   }


function groupMenuExploreItems(menuItems: any) {
  // PayLink and other non-menu responses do not always provide menu items as
  // an array. There is simply nothing to group for Explore in that case.
  if (!Array.isArray(menuItems)) return [];

  const groupedItems = menuItems.reduce((acc: any[], currentItem: any) => {
    if (!currentItem?.isSpecial || !Array.isArray(currentItem?.specialCategory)) {
      return acc;
    }

    // Loop through ALL special categories for this item
    currentItem.specialCategory.forEach((sc: any) => {
      if (!sc?.specialName) return;

      // Find group by specialName
      let existingGroup = acc.find(
        (group) =>
          group.title?.toLowerCase() === sc.specialName?.toLowerCase()
      );

      if (!existingGroup) {
        existingGroup = {
          title: sc.specialName,
          displayType: currentItem?.digiMenuMedia?.[0]?.tag ?? null,
          desc: sc?.categoryDescription ?? null,
          content: [],
        };
        acc.push(existingGroup);
      }

      // Push item (allowed to appear in multiple groups)
      existingGroup.content.push({
        image: Array.isArray(currentItem?.digiMenuMedia)
          ? currentItem.digiMenuMedia
          : [],
        dishName: currentItem?.itemName,
        menuData: currentItem,
      });
    });

    return acc;
  }, []);


  return groupedItems;
}


  return {groupMenuExploreItems};
};


export default useFunctions;
